import script from "./SplashScreen.vue?vue&type=script&setup=true&lang=ts"
export * from "./SplashScreen.vue?vue&type=script&setup=true&lang=ts"

import "./SplashScreen.vue?vue&type=style&index=0&id=3ccd2a69&lang=less"

const __exports__ = script;

export default __exports__